import {Component, OnDestroy} from "@angular/core";
import {
  NavController,
  NavParams,
  ModalController,
  AlertController,
  LoadingController
} from "ionic-angular";
import {FirebaseProvider} from "./../../providers/firebase/firebase";
import {Subscription} from "rxjs";
import {HttpParams} from "@angular/common/http";
import Hashids from "hashids";
import L from "leaflet";
import 'leaflet-routing-machine';
import {MapdirectionsProvider} from "./../../providers/mapdirections/mapdirections";
import * as moment from "moment";
import {AppState} from "../../app/app.global";
import {Title} from "@angular/platform-browser";
import {isRightSide} from "ionic-angular/umd/util/util";
import { MAPBOXTOKEN } from "../constants";

@Component({
  selector: "page-home",
  templateUrl: "home.html"
})
export class HomePage implements OnDestroy {
  TMOneServiceId: number;
  public activeService: any;
  public statusObjects: any;
  public latIni: any = 0;
  public lonIni: any = 0;
  public latFin: any = 0;
  public lonFin: any = 0;
  arrayStatus: any;
  directions: any;
  refPhotos: any;
  photosService: any = [];
  serviceActiveKey: string;
  reference: string;
  subscribeService: Subscription;

  newNotif: {
    tokens: [string];
    payload: {
      notification: {
        title: string;
        body: string;
      };
      data: Object;
    };
    options: {
      priority: "high";
      timeToLive: number;
    };
  };
  adminData: any;
  adminDataTelemedic: any;
  driverDeviceKey: any;
  serviceTitle: any;
  servicePast: boolean = false;
  arrived: boolean = false;
  acepted: boolean = false;
  countChat: number = 0;
  canceled: boolean = false;
  canceledDate: any;
  esGrua: boolean = false;
  serviceIdParams: number;
  tracking: any;
  trackingDirections: any;
  arribo: boolean = false;
  loading: any;

  routesInfo: any;
  driverRoutes: any;

  // Leaflet
  leaftMap: any;
  layerTrack = null;
  layerAB = null;
  townMarker = null;
  markService = null;
  markDest = null;
  kmTrack: any;
  kmabRoute: any;
  timeTrack: any;
  timeabRoute: any;
  trackingSucess: boolean = false;
  trackingDanger: boolean = false;
  hacerZoom: boolean = false;
  mapReady: boolean = false;
  carIcon = L.icon({
    iconUrl: "assets/img/car-map-icon.png",
    iconSize: [43, 24],
    iconAnchor: [27, 23],
    popupAnchor: [-1, -20]
  });

  endIcon = L.icon({
    iconUrl: "assets/img/finish-map-icon.png",
    iconSize: [24, 24],
    iconAnchor: [8, 23],
    popupAnchor: [-1, -20]
  });

  townIcon = L.icon({
    iconUrl: "assets/img/tow-map-icon.png",
    iconSize: [43, 24],
    iconAnchor: [27, 23],
    popupAnchor: [-1, -20]
  });
  //leaflet
  selectedStep: number = 0;
  arrayStatusDefault = [
    {
      name: "Orden enviada",
      timestamp: 0,
      index: 0
    },
    {
      name: "Proveedor asignado",
      timestamp: 0,
      index: 1
    },
    {
      name: "Proveedor en camino",
      timestamp: 0,
      index: 1
    },
    {
      name: "El proveedor arribó",
      timestamp: 0,
      index: 2
    },
    {
      name: "Servicio terminado",
      timestamp: 0,
      index: 3
    }
  ];
  ordenEnviada: any;

  // Header
  // --
  onloadingHeader = true
  SURA_CAMPAING_NAME = 'Seguros SURA'
  URGE_GRUA_CAMPAING_NAME = 'AsistCo'
  GNP_CAMPAING_NAME = 'GNP'
  isChatAvailable = false
  routesTrack: any;

  private statusSub: Subscription;
  private photosSub: Subscription;
  private photosRefSub: Subscription;
  private trackingDriverChangeSub: Subscription;
  private trackingDriverLocationSub: Subscription;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public fbProvider: FirebaseProvider,
    public modalCtrl: ModalController,
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    public MapPvr: MapdirectionsProvider,
    public global: AppState,
    private title: Title
  ) {
    const url = window.location.href;
    const hashids = new Hashids("coppel-telasist", 10);

    let paramValue;
    if (url.includes("?")) {
      const httpParams = new HttpParams({fromString: url.split("?")[1]});
      paramValue = httpParams.get("servicio");
      this.serviceIdParams = Number(hashids.decode(paramValue));
      this.loading = this.loadingCtrl.create({
        content: "Espere por favor..."
      });
      this.loading.present();
    } else {
      this.serviceIdParams = 0;
    }

    this.verServicio();
  }

  ionViewDidLoad() {
    if (this.mapReady == false && this.serviceIdParams != 0) {
      this.createMap(); // Crear Mapa
    }
  }

  createMap() {
    this.hacerZoom = true;
    this.leaftMap = L.map("leaftMap").setView(
      [19.4326077, -99.13320799999997],
      12
    );

    L.tileLayer("https://maps.tmapi.tech/hot/{z}/{x}/{y}.png", {
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(this.leaftMap);
  }

  verServicio() {
    this.subscribeService = this.fbProvider
      .getItemsQuery(
        "service/",
        "TMOneServiceId",
        this.serviceIdParams, //ID tomado de la URL
        Number(1)
      )
      .snapshotChanges()
      .subscribe(serviceData => {
        if (serviceData.length === 0) {
          if (!!this.loading) {
            this.loading.dismiss()
            this.loading = null
          }
          return
        }

        serviceData.map(val => {
          let snapshot: any = val.payload.val();

          this.changeTheme(snapshot.campana)
          this.displayChat(snapshot.campana)

          //Revisa si de Coppel
          // if (snapshot.campana !== "Coppel") {
          //   this.esCoppel = false;
          //   this.alert();
          // }

          //Servicio activo
          if (snapshot.active === true) {
            if (this.loading) {
              this.loading.dismiss();
              this.loading = null;
            }
            this.servicePast = false;
            this.serviceTitle = "en curso";
            this.serviceActiveKey = val.key; //key del servicio activo
            this.activeService = snapshot;
            this.reference = this.activeService.startPoint.reference;
            this.statusObjects = this.activeService.status;
            this.tracking = this.activeService.Tracking;
            this.ordenEnviada = this.statusObjects[0].timestamp;
            if (snapshot.hasOwnProperty("canceled")) {
              this.canceled = true;
              for (let i = 0; i < this.statusObjects.length; i++) {
                if (this.statusObjects[i].name == "Servicio cancelado") {
                  this.canceledDate = this.statusObjects[i].timestamp;
                }
              }
            }

            if (this.activeService.service_type.id == 1) {
              this.esGrua = true;
              if (this.hacerZoom == true) {
                this.leaftMap.flyTo(
                  [
                    this.activeService.startPoint.lat,
                    this.activeService.startPoint.lon
                  ],
                  13,
                  {
                    animate: false
                  }
                );
                this.hacerZoom = false;
              }

              this.calcRoute(this.activeService.startPoint.lat, this.activeService.startPoint.lon, this.activeService.endPoint.lat, this.activeService.endPoint.lon, 'blue')

              // this.getRoute(
              //   this.activeService.startPoint.lat,
              //   this.activeService.startPoint.lon,
              //   this.activeService.endPoint.lat,
              //   this.activeService.endPoint.lon,
              //   "routeab"
              // ).then(() => {
              //   if (!this.markService) {
              //     this.markService = L.marker(
              //       [
              //         this.activeService.startPoint.lat,
              //         this.activeService.startPoint.lon
              //       ],
              //       { draggable: false, icon: this.carIcon }
              //     )
              //       .bindPopup("Ubicación de " + this.activeService.user.nombre)
              //       .addTo(this.leaftMap);
              //   } else {
              //     this.markService.setLatLng([
              //       this.activeService.startPoint.lat,
              //       this.activeService.startPoint.lon
              //     ]);
              //   }

              //   if (!this.markDest) {
              //     this.markDest = L.marker(
              //       [
              //         this.activeService.endPoint.lat,
              //         this.activeService.endPoint.lon
              //       ],
              //       { draggable: false, icon: this.endIcon }
              //     )
              //       .bindPopup("Destino:" + this.activeService.endPoint.dir)
              //       .addTo(this.leaftMap);
              //   } else {
              //     this.markDest.setLatLng([
              //       this.activeService.endPoint.lat,
              //       this.activeService.endPoint.lon
              //     ]);
              //   }
              // });


            } else {
              this.esGrua = false;
              if (this.hacerZoom == true) {
                this.leaftMap.flyTo(
                  [
                    this.activeService.startPoint.lat,
                    this.activeService.startPoint.lon
                  ],
                  12,
                  {
                    animate: false
                  }
                );
                this.hacerZoom = false;
              }
              if (!this.markService) {
                this.markService = L.marker(
                  [
                    this.activeService.startPoint.lat,
                    this.activeService.startPoint.lon
                  ],
                  {draggable: false, icon: this.carIcon}
                )
                  .bindPopup("Ubicación de " + this.activeService.user.nombre)
                  .addTo(this.leaftMap);
              } else {
                this.markService.setLatLng([
                  this.activeService.startPoint.lat,
                  this.activeService.startPoint.lon
                ]);
              }
            }

            if (this.activeService.hasOwnProperty("arrived")) {
              this.arrived = this.activeService.arrived;
            }

            if (this.activeService.hasOwnProperty("acepted")) {
              this.acepted = this.activeService.acepted;
            }

            // this function replaces the tracking by Tracking attribute
            this.fetchTrackingByDriver(this.serviceActiveKey, '/service', this.activeService.driver ? this.activeService.driver.id : null);

            // the following block is commented because of the previous function implementation
            /*if (typeof this.activeService.Tracking !== "undefined") {
              //Pinta la linea de Traking
              this.calcularMinutosTracking(
                this.activeService.Tracking.timestamp
              );


              this.calcRouteTracking(this.activeService.startPoint.lat, this.activeService.startPoint.lon, this.activeService.endPoint.lat, this.activeService.endPoint.lon, 'green')


              // this.getRoute(
              //   this.activeService.Tracking.lat,
              //   this.activeService.Tracking.lon,
              //   this.activeService.startPoint.lat,
              //   this.activeService.startPoint.lon,
              //   "track"
              // ).then(() => {
              //   if (!this.townMarker) {
              //     this.townMarker = L.marker(
              //       [
              //         this.activeService.Tracking.lat,
              //         this.activeService.Tracking.lon
              //       ],
              //       { icon: this.townIcon }
              //     )
              //       .bindPopup(
              //         "Proveedor asignado " + this.activeService.driver.name
              //       )
              //       .addTo(this.leaftMap);
              //   }
              //   this.townMarker.setLatLng([
              //     this.activeService.Tracking.lat,
              //     this.activeService.Tracking.lon
              //   ]);
              // });
            }*/
          }

          //Servicio NO activo, servicios pasados
          if (!snapshot.active) {
            if (this.loading) {
              this.loading.dismiss();
              this.loading = null;
            }
            this.subscribeService.unsubscribe();
            if (snapshot.hasOwnProperty("canceled")) {
              this.canceled = true;
              // console.log("servicio Cancelado");
              if (snapshot.canceled.type !== "Usuario") {
                let alert = this.alertCtrl.create({
                  message: "El servicio ha sido cancelado",
                  buttons: [
                    {
                      text: "Ok",
                      role: "cancel",
                      handler: () => {
                      }
                    }
                  ]
                });
                alert.present();
              }
            }
            this.servicePast = true;
            this.serviceTitle = "pasado";
            this.serviceActiveKey = val.key; //key del servicio pasado
            this.startServiceRanking()
            this.activeService = snapshot;
            this.reference = this.activeService.startPoint.reference;
            this.statusObjects = this.activeService.status;
            this.ordenEnviada = this.statusObjects[0].timestamp;
            if (snapshot.hasOwnProperty("canceled")) {
              this.canceled = true;
              for (let i = 0; i < this.statusObjects.length; i++) {
                if (this.statusObjects[i].name == "Servicio cancelado") {
                  this.canceledDate = this.statusObjects[i].timestamp;
                }
              }
            }
            if (this.activeService.service_type.id == 1) {
              this.esGrua = true;
              this.calcRoute(this.activeService.startPoint.lat, this.activeService.startPoint.lon, this.activeService.endPoint.lat, this.activeService.endPoint.lon, 'blue')

              // this.leaftMap.flyTo(
              //   [
              //     this.activeService.startPoint.lat,
              //     this.activeService.startPoint.lon
              //   ],
              //   10,
              //   {
              //     animate: false
              //   }
              // );
              // this.getRoute(
              //   this.activeService.startPoint.lat,
              //   this.activeService.startPoint.lon,
              //   this.activeService.endPoint.lat,
              //   this.activeService.endPoint.lon,
              //   "routeab"
              // ).then(() => {
              //   if (!this.markService) {
              //     this.markService = L.marker(
              //       [
              //         this.activeService.startPoint.lat,
              //         this.activeService.startPoint.lon
              //       ],
              //       { draggable: false, icon: this.carIcon }
              //     )
              //       .bindPopup("Ubicación de " + this.activeService.user.nombre)
              //       .addTo(this.leaftMap);
              //   } else {
              //     this.markService.setLatLng([
              //       this.activeService.startPoint.lat,
              //       this.activeService.startPoint.lon
              //     ]);
              //   }

              //   if (!this.markDest) {
              //     this.markDest = L.marker(
              //       [
              //         this.activeService.endPoint.lat,
              //         this.activeService.endPoint.lon
              //       ],
              //       { draggable: false, icon: this.endIcon }
              //     )
              //       .bindPopup("Destino:" + this.activeService.endPoint.dir)
              //       .addTo(this.leaftMap);
              //   } else {
              //     this.markDest.setLatLng([
              //       this.activeService.endPoint.lat,
              //       this.activeService.endPoint.lon
              //     ]);
              //   }
              // });
            } else {
              this.esGrua = false;
              this.leaftMap.flyTo(
                [
                  this.activeService.startPoint.lat,
                  this.activeService.startPoint.lon
                ],
                18,
                {
                  animate: false
                }
              );
              if (!this.markService) {
                this.markService = L.marker(
                  [
                    this.activeService.startPoint.lat,
                    this.activeService.startPoint.lon
                  ],
                  {draggable: false, icon: this.carIcon}
                )
                  .bindPopup("Ubicación de " + this.activeService.user.nombre)
                  .addTo(this.leaftMap);
              } else {
                this.markService.setLatLng([
                  this.activeService.startPoint.lat,
                  this.activeService.startPoint.lon
                ]);
              }
            }

            if (this.activeService.hasOwnProperty("arrived")) {
              this.arrived = this.activeService.arrived;
            }
            if (this.activeService.hasOwnProperty("acepted")) {
              this.acepted = this.activeService.acepted;
            }

            this.subscribeService.unsubscribe();
          }
        });

        //Array de referencias fotográficas
        if (this.photosRefSub) {
          this.photosRefSub.unsubscribe();
        }
        this.photosRefSub = this.fbProvider
          .getItems("service/" + this.serviceActiveKey + "/refphoto")
          .valueChanges()
          .subscribe(_arrayPhotos => {
            this.refPhotos = _arrayPhotos;
          });

        //Array de evidencias fotográficas del servicio
        if (this.photosSub) {
          this.photosSub.unsubscribe();
        }
        this.photosSub = this.fbProvider
          .getItems("service/" + this.serviceActiveKey + "/photos")
          .valueChanges()
          .subscribe(_servicePhotos => {
            if(_servicePhotos.length>0){
              console.log(_servicePhotos.length);
              _servicePhotos.forEach(item => {
                this.photosService.push(item);
              });
            }
            console.log(this.photosService);
            //this.photosService = _servicePhotos;
          });
        //Array de status
        if (this.statusSub) {
          this.statusSub.unsubscribe();
        }
        this.statusSub = this.fbProvider
          .getItems("service/" + this.serviceActiveKey + "/status")
          .valueChanges()
          .subscribe(_arrayStatus => {
            this.arrayStatus = _arrayStatus;
            // Recorre los estatus que hay en FB
            for (var j = 0; j < this.arrayStatus.length; j++) {
              // Si el estatus de FB encaja en los de default entonces...
              switch (this.arrayStatus[j].name) {
                case "Orden enviada":
                  this.selectedStep = 0;
                  this.arrayStatusDefault[0].timestamp = this.arrayStatus[
                    j
                    ].timestamp;
                  break;
                case "Proveedor asignado":
                  this.selectedStep = 1;
                  this.arrayStatusDefault[1].timestamp = this.arrayStatus[
                    j
                    ].timestamp;
                  break;
                case "Proveedor en camino":
                  this.selectedStep = 2;
                  this.arrayStatusDefault[2].timestamp = this.arrayStatus[
                    j
                    ].timestamp;
                  break;
                case "Servicio en curso":
                  this.selectedStep = 2;
                  this.arrayStatusDefault[3].timestamp = this.arrayStatus[
                    j
                    ].timestamp;
                  break;
                case "El proveedor arribó":
                  this.selectedStep = 3;
                  this.arrayStatusDefault[3].timestamp = this.arrayStatus[
                    j
                    ].timestamp;
                  break;
                case "Servicio terminado":
                  this.selectedStep = 4;
                  this.arrayStatusDefault[4].timestamp = this.arrayStatus[
                    j
                    ].timestamp;
                  break;

                default:
                  break;
              }
            }
          });
      });
  }

  dirChange(event: any) {
    // console.log(event);
  }

  private calcRoute(origenLat, origenLon, destinoLat, destinoLon, type) {

    if (this.routesInfo) {
      this.routesInfo.spliceWaypoints(0, 2);
    }
    this.routesInfo = L.Routing.control({
      waypoints: [
        L.latLng(origenLat, origenLon),    // startmarker
        L.latLng(destinoLat, destinoLon) // endmarker
      ], lineOptions: {
        styles: [{color: type, opacity: 1, weight: 5}]
      },
      createMarker(i, wp, nWps) {
        let carIcon = L.icon({
          iconUrl: "assets/img/car-map-icon.png",
          iconSize: [43, 24],
          iconAnchor: [27, 23],
          popupAnchor: [-1, -20]
        });
        let endIcon = L.icon({
          iconUrl: "assets/img/finish-map-icon.png",
          iconSize: [24, 24],
          iconAnchor: [8, 23],
          popupAnchor: [-1, -20]
        });
        let marker_icon = null;
        if (i == 0) {
          marker_icon = carIcon;
        } else if (i == nWps - 1) {
          marker_icon = endIcon;
        }
        return L.marker(wp.latLng, {
          icon: marker_icon // here pass the custom marker icon instance
        });
      },
      router: L.Routing.mapbox(
        MAPBOXTOKEN,
        'truck'
      ),
    }).addTo(this.leaftMap);

    if (this.routesInfo != undefined) {
      this.routesInfo.hide();
    }

    const self = this;
    this.routesInfo.on('routesfound', function (e) {
      const routes = e.routes;
    });
  }


  private calcRouteTracking(origenLat, origenLon, destinoLat, destinoLon, type) {

    if (this.routesInfo) {
      this.routesInfo.spliceWaypoints(0, 2);
    }
    this.routesTrack = L.Routing.control({
      waypoints: [
        L.latLng(origenLat, origenLon),    // startmarker
        L.latLng(destinoLat, destinoLon) // endmarker
      ], lineOptions: {
        styles: [{color: type, opacity: 1, weight: 5}]
      },
      createMarker(i, wp, nWps) {
        let carIcon = L.icon({
          iconUrl: "assets/img/car-map-icon.png",
          iconSize: [43, 24],
          iconAnchor: [27, 23],
          popupAnchor: [-1, -20]
        });
        let endIcon = L.icon({
          iconUrl: "assets/img/finish-map-icon.png",
          iconSize: [24, 24],
          iconAnchor: [8, 23],
          popupAnchor: [-1, -20]
        });
        let marker_icon = null;
        if (i == 0) {
          marker_icon = carIcon;
        } else if (i == nWps - 1) {
          marker_icon = endIcon;
        }
        return L.marker(wp.latLng, {
          icon: marker_icon // here pass the custom marker icon instance
        });
      },
      router: L.Routing.mapbox(
        MAPBOXTOKEN,
        'truck'
      ),
    }).addTo(this.leaftMap);

    if (this.routesTrack != undefined) {
      this.routesTrack.hide();
    }

    const self = this;
    this.routesTrack.on('routesfound', function (e) {
      const routes = e.routes;
    });
  }


  openChat() {
    let myModal = this.modalCtrl.create("ChatPage", {
      idService: this.serviceActiveKey,
      idCompany: this.activeService.company.id,
      TMOneServiceId: this.activeService.TMOneServiceId,
      serviceName: this.activeService.service_type.name,
      userName: this.activeService.user.nombre,
      userLastName: this.activeService.user.apellidos
    });
    myModal.present();
  }

  alert() {
    let alert = this.alertCtrl.create({
      title: "Error",
      message: "El servicio no existe",
      buttons: ["Ok"]
    });
    alert.present();
  }

  async getRoute(latIni, lonIni, latFin, lonFin, type) {
    this.timeTrack = null;
    this.timeabRoute = null;
    this.kmTrack = null;
    this.kmabRoute = null;
    let point = latIni.toString() + "," + lonIni.toString();
    let startPoint = latFin.toString() + "," + lonFin.toString();
    let self = this;

    await this.MapPvr.getRoute(point, startPoint).subscribe(
      function (response) {
        this.httpResponse = response;
      },
      function (error) {
        console.log("Error happened" + error);
      },
      function (this) {
        var array = this.httpResponse["body"];
        let metre = array.routes[0].distance;
        let km = Math.round(metre / 100) / 10;
        let duration = array.routes[0].duration;
        let time = moment.utc(duration * 1000).format("HH:mm:ss");
        switch (type) {
          case "track":
            self.kmTrack = km;
            self.timeTrack = time;
            let styleTown = {
              color: "#5bff5b",
              weight: 5,
              opacity: 0.65
            };
            switch (self.layerTrack) {
              case null:
                self.layerTrack = L.geoJSON(array.routes[0].geometry, {
                  style: styleTown
                }).addTo(self.leaftMap);
                self.layerTrack;
                break;

              default:
                self.layerTrack.clearLayers();
                self.layerTrack.addData(array.routes[0].geometry);
                break;
            }
            break;

          default:
            self.kmabRoute = km;
            self.timeabRoute = time;
            let styleAB = {
              color: "#2084d8",
              weight: 5,
              opacity: 0.65
            };
            switch (self.layerAB) {
              case null:
                self.layerAB = L.geoJSON(array.routes[0].geometry, {
                  style: styleAB
                }).addTo(self.leaftMap);
                self.layerAB;
                break;

              default:
                self.layerAB.clearLayers();
                self.layerAB.addData(array.routes[0].geometry);
                break;
            }
            break;
        }
      }
    );
  }

  calcularMinutosTracking(_hora) {
    var today = new Date();
    var fechaSplit = today.toLocaleDateString().split("/");
    var newFechaSplit =
      fechaSplit[1] + "/" + fechaSplit[0] + "/" + fechaSplit[2]; // mes, día,  año
    var todayTMP = Date.parse(newFechaSplit + " " + today.toLocaleTimeString());
    var minutosTracking = (todayTMP - _hora) / 60000;
    if (minutosTracking > 5 && _hora != todayTMP) {
      //si pasan más de 5 min y la hora actual es diferente a la última hora del tracking
      this.trackingDanger = true;
      this.trackingSucess = false;
    } else {
      this.trackingSucess = true;
      this.trackingDanger = false;
    }
  }

  changeTheme(campana) {
    if (campana === this.SURA_CAMPAING_NAME) {
      this.global.set('theme', 'theme-sura')
      this.global.set('logo', 'logo-white-2.png')
      this.onloadingHeader = false
    } else if (campana === this.URGE_GRUA_CAMPAING_NAME) {
      const link: any = document.querySelector("link[rel~='icon']");
      if (link) {
        link.href = '/assets/icon/urge-favicon.png';
      }
      this.title.setTitle('Urge Grúa');
      this.global.set('theme', 'theme-urge')
      this.global.set('logo', 'logo-grua-white.png')
      this.onloadingHeader = false
    } else {
      this.onloadingHeader = false
    }
  }

  displayChat(campana) {
    if (campana === this.SURA_CAMPAING_NAME || campana === this.GNP_CAMPAING_NAME) {
      this.isChatAvailable = true
    }
  }

  startServiceRanking() {
    if (!this.serviceActiveKey) return

    let serviceStatus = this.fbProvider
      .getObject("service/" + this.serviceActiveKey)
      .snapshotChanges()
      .subscribe({
          next: (value) => {
            let singleService: any = value.payload.val()

            if (!!singleService) {
              // Detecting service done
              let statusServiceDone = singleService.status.filter(v => v.name === 'Servicio terminado')
              // Detecting service done not ranked
              if (statusServiceDone.length > 0 && !singleService.acepted
                && !singleService.active && !singleService.rating) {
                this.navCtrl.push("CalificarPage", {
                  service_key: this.serviceActiveKey,
                  service: singleService,
                  telefono: ''
                })
              }
            }

            // stop listening
            if (!!serviceStatus)
              serviceStatus.unsubscribe()
          },
          error: (error) => {
            console.error("Something went wrong: ", error)
            if (!!serviceStatus)
              serviceStatus.unsubscribe()
          }
        }
      )
  }

  private fetchTrackingByDriver(key, fb, driverId) {

    if (this.trackingDriverChangeSub) {
      this.trackingDriverChangeSub.unsubscribe();
    }
    if (driverId) {
      if (this.trackingDriverLocationSub) {
        this.trackingDriverLocationSub.unsubscribe();
      }
      this.trackingDriverLocationSub = this.fbProvider.getTrackingPointByDriverId(driverId).subscribe((res) => {
        this.trackService(res);
      });
    } else {
      this.trackingDriverChangeSub = this.fbProvider.getServiceDriver(key, fb).subscribe((res: any) => {
        if (res.id && res.id.toString().length > 0) {
          this.fetchTrackingByDriver(key, fb, res.id);
        }
      });
    }
  }

  private trackService(driverLocation) {

    this.calcularMinutosTracking(
      driverLocation.date
    );
    // this.calcRouteTracking(this.activeService.startPoint.lat, this.activeService.startPoint.lon, this.activeService.endPoint.lat, this.activeService.endPoint.lon, 'green')
    // this.getRoute(
    //   driverLocation.lat,
    //   driverLocation.lon,
    //   this.activeService.startPoint.lat,
    //   this.activeService.startPoint.lon,
    //   "track"
    // ).then(() => {
    //   if (!this.townMarker) {
    //     this.townMarker = L.marker(
    //       [
    //         driverLocation.lat,
    //         driverLocation.lon
    //       ],
    //       {icon: this.townIcon}
    //     )
    //       .bindPopup(
    //         "Proveedor asignado " + this.activeService.driver.name
    //       )
    //       .addTo(this.leaftMap);
    //   }
    //   this.townMarker.setLatLng([
    //     driverLocation.lat,
    //     driverLocation.lon
    //   ]);
    // });

    const destinationLocation = this.selectedStep >= 3 ? this.activeService.endPoint : this.activeService.startPoint;
    if (this.driverRoutes) {
      this.driverRoutes.spliceWaypoints(0, 2);
    }

    if (!destinationLocation || !destinationLocation.lat) {
      if (this.driverRoutes != undefined) {
        this.driverRoutes.hide();
      }
      return;
    }
    this.driverRoutes = L.Routing.control({
      waypoints: [
        L.latLng(driverLocation.lat, driverLocation.lon),    // startmarker
        L.latLng(destinationLocation.lat, destinationLocation.lon) // endmarker
      ], lineOptions: {
        styles: [{color: 'green', opacity: 1, weight: 5}]
      },
      createMarker(i, wp, nWps) {
        let carIcon = L.icon({
          iconUrl: "assets/img/tow-map-icon.png",
          iconSize: [43, 24],
          iconAnchor: [27, 23],
          popupAnchor: [-1, -20]
        });
        let endIcon = L.icon({
          iconUrl: "assets/img/finish-map-icon.png",
          iconSize: [24, 24],
          iconAnchor: [8, 23],
          popupAnchor: [-1, -20]
        });
        let marker_icon = null;
        if (i == 0) {
          marker_icon = carIcon;
        } else if (i == nWps - 1) {
          marker_icon = endIcon;
          return null;
        }
        return L.marker(wp.latLng, {
          icon: marker_icon // here pass the custom marker icon instance
        });
      },
      router: L.Routing.mapbox(
        MAPBOXTOKEN,
        'truck'
      ),
    }).addTo(this.leaftMap);

    if (this.driverRoutes != undefined) {
      this.driverRoutes.hide();
    }
  }

  ngOnDestroy(): void {
    if (this.trackingDriverChangeSub) {
      this.trackingDriverChangeSub.unsubscribe();
    }
  }


}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts